import { safeRandomUUID } from '#pplx/frontend/common/safeRandomUUID.js';
import { CF_CHALLENGE_403_CODES, getFetcherErrorCode } from '#pplx/frontend/fetcher/errors.js';
import { reportAction } from '#pplx/frontend/metrics/browser.js';
const RELOAD_COUNT_KEY = 'pplx.cfChallengeReload.count';
const MAX_RELOADS_PER_SESSION = 3;
const CF_CHALLENGE_RELOAD_FIRED_ACTION = 'web.frontend.cf_challenge_reload.fired';
const CHALLENGE_PATH = '/challenge';
// Build a unique, cache-busting URL to the /challenge route. The `challenge_id`
// defeats the service-worker / browser cache so the navigation actually reaches
// Cloudflare's edge (a plain reload can be served from cache and never surfaces
// the interstitial); it's also reported to Datadog under the same key so a
// fired event can be correlated with the resulting /challenge request in the
// edge logs. `return` is the page to send the user back to once the challenge
// clears; the caller is responsible for passing a backend-valid location (e.g.
// not an ephemeral, not-yet-created thread URL), and /challenge re-validates it
// to a same-origin relative path.
function buildChallengeUrl(returnUrl, challengeId) {
    const params = new URLSearchParams({
        challenge_id: challengeId,
        return: returnUrl,
    });
    return `${CHALLENGE_PATH}?${params.toString()}`;
}
export function tryConsumeCfChallengeReload() {
    if (typeof window === 'undefined') {
        return false;
    }
    // Accessing window.sessionStorage can throw in some browsers when
    // storage is disabled (cookies blocked, Safari private mode, etc.).
    let storage;
    try {
        storage = window.sessionStorage;
    }
    catch {
        return false;
    }
    if (!storage) {
        return false;
    }
    let count;
    try {
        const raw = storage.getItem(RELOAD_COUNT_KEY);
        count = raw === null ? 0 : Number.parseInt(raw, 10);
        if (!Number.isFinite(count) || count < 0) {
            count = 0;
        }
    }
    catch {
        return false;
    }
    if (count >= MAX_RELOADS_PER_SESSION) {
        return false;
    }
    try {
        storage.setItem(RELOAD_COUNT_KEY, String(count + 1));
    }
    catch {
        return false;
    }
    return true;
}
export function maybeReloadForCfChallenge(err, enabled, returnUrl) {
    if (!enabled || typeof window === 'undefined')
        return false;
    const code = getFetcherErrorCode(err);
    if (code === undefined || !CF_CHALLENGE_403_CODES.has(code))
        return false;
    if (!tryConsumeCfChallengeReload())
        return false;
    const challengeId = safeRandomUUID();
    try {
        reportAction(CF_CHALLENGE_RELOAD_FIRED_ACTION, {
            trigger: code === 'FETCHER_SSE_CLOUDFLARE_403_ERROR' ? 'sse_cloudflare_403' : 'rest_cloudflare_403',
            // Same challenge_id as the /challenge URL param, so the Datadog action can
            // be correlated with the resulting edge request.
            challenge_id: challengeId,
        });
    }
    catch {
        // Tracking should never block challenge recovery.
    }
    window.location.assign(buildChallengeUrl(returnUrl, challengeId));
    return true;
}
//# sourceMappingURL=cfChallengeReload.js.map